import { CommandController } from './../../../commanding/CommandController';
import { SimpleCommand } from './../../../commanding/SimpleCommand';


import { BasicController } from "../BasicController";

export class BasicConnectionTimeoutCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        CommandController.instance.executeCommand(BasicController.COMMAND_PREPARE_RECONNECT);
    }
}

